import { faFemale, faMale } from "@fortawesome/free-solid-svg-icons";

enum Gender {
    Unknown = 0,
    Male = 1,
    Female = 2
}

export default Gender;

export const formatExtraData = {
    [Gender.Male]: faMale,
    [Gender.Female]: faFemale,
    [Gender.Unknown]: "",
  };
